<template>
  <!--需改密码-->
  <el-dialog title="修改密码" :visible.sync="centerDialogVisible" width="22%" :before-close="closeHandle">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
      <el-form-item label="密码" prop="pass">
        <el-input type="password" v-model="ruleForm.pass" placeholder="必须包含数字、大写、小写字母且长度不能小于8位" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input type="password" v-model="ruleForm.checkPass" placeholder="必须包含数字、大写、小写字母且长度不能小于8位" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { updatePasswd } from "@/api/login";

export default {
  name: "ChangePassword",
  props: {
    // 数据总条数
    centerDialogVisible: Boolean,
    userId: String,
  },
  components: {},
  data() {
    const validatePass = (rule, value, callback) => {
      const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!pattern.test(value)) {
        callback(new Error("密码必须包含数字、大写、小写字母且长度不能小于8位"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };

    const validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        pass: "",
        checkPass: "",
      },
      rules: {
        pass: [{ required: true, validator: validatePass, trigger: "blur" }],
        checkPass: [{ required: true, validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    closeHandle() {
      this.$emit("close");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updatePasswd({
            userId: this.userId,
            newPwd: this.ruleForm.pass,
            oldPwd: "",
          })
            .then((res) => {
              if (res) {
                this.$message.success("密码重置成功,请重新登录！");
                setTimeout(() => {
                  localStorage.clear();
                  this.$router.replace("/login", () => {});
                }, "800");
              }
            })
            .catch((e) => {
              this.$message.warning(e.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped></style>
